import { LandingPage } from '../LandingPage';
import { clinicsConfig } from './config';

export default function ClinicsLandingPage() {
  return <LandingPage config={clinicsConfig} />;
}
